import {RequestedProcedure} from "./requested.procedure";
import {OrderedProcedureItem} from "./ordered.procedure.item";
import {ALookupRowsContainer} from "./lookup.rows.container";
import {Sps} from "./sps";
import  {ScanDocument} from './scan.document';
import {Calculated} from "../../metadata/decorators/calculated.decorator";
import * as moment from "moment";
import * as _ from "lodash";

/**
 * actual class for a visit, including functions.
 * this class should somehow by dynamically extended in the future - for now
 * we have some static methods on it and in the future we will enable dynamic extensions for it
 */
export class Order extends ALookupRowsContainer {
	static requestedProcedure_TYPE;
	static orderedProcedureItem_TYPE;
	static scanDocument_TYPE;

	scanDocument: ScanDocument[];
	orderKey: number;
	reasonForOrder: string;
	// cbOPregnant;
	// cbOHeight;
	// cbOWeight;
	accessionNumber: string;
	orderPersonReference: any[];
	orderedProcedureItem: OrderedProcedureItem[];
	siteProtCOMr: any[];
	requestedProcedure: RequestedProcedure[];
	//siteProtCOClinicalInd;
	statusKey: number;
	signedByResourceIdKey: number;
	createdByResourceIdKey:number;
	createdOnDate: Date;
	requestDatetime: Date;
	orgStructureKey: number;
	suggestedSchedStartDatetime: Date;
	suggestedSchedEndDatetime: Date;
	scheduleSchemeKey: number;
	followupPpsKey: number;

	justificationStatusKey: number;


	get noScannedOrder() {
		return !(this.scanDocument && this.scanDocument.find(function (d) {
			return (d.scanDocTypeKey === 12288);
		}));
	}

	get orderedRPCodes() {
		return this.orderedProcedureItem.map(orderedItem => orderedItem.rpCodeKey);
	}

	get firstRequestedProcedure() {
		let prop = 'requestedProcedure';
		if (!this[prop] || !this[prop][0]) {
			this[prop] = [{}];
		}
		return this[prop][0];
	}

	get isNotMRProcedures() {
		let mrRPCodes: any[] = [16012, 16522, 16582, 15979, 15979, 15981, 15981, 15983, 15983, 16521, 16518, 16518, 16019, 16019, 15982, 15982];
		return (this.orderedProcedureItem.filter((item) => {
			return (mrRPCodes.indexOf(item.rpCodeKey) > -1);
		}).length === 0 );
	}

	get firstSiteProtCOClinicalInd() {
		let prop = 'siteProtCOClinicalInd';
		if (!this[prop] || !this[prop][0]) {
			this[prop] = [{}];
		}
		return this[prop][0];
	}

	get firstSiteProtCOMr() {
		let prop = 'siteProtCOMr';
		if (!this[prop] || !this[prop][0]) {
			//temp until the server side gets this automatically
			this[prop] = [{}];
		}
		return this[prop][0];
	}

	get firstSiteProtCOJustProt() {
		let prop = 'siteProtCOJustProt';
		if (!this[prop] || !this[prop][0]) {
			this[prop] = [{}];
		}
		return this[prop][0];
	}

	getSpsBySpsCodeKey(spsCodeKey: number): Sps {
		return this.getAllSpsEntries().find((sps: Sps) => (<any>sps).spsCodeKey === spsCodeKey);
	}

	getAllSpsEntries(): Sps[] {
		return !this.requestedProcedure || this.requestedProcedure.length === 0 ? [] :
			_.flatten(this.requestedProcedure.map((requestedProcedure: RequestedProcedure) => requestedProcedure.sps));
	}

	public isMetalIndication() {
		if (this.isNotMRProcedures) {
			return false;
		}

		let firstSiteProtCOMr = this.firstSiteProtCOMr;

		let keys = ['cbIsSpoAneurysmClips', 'cbIsSpoMetallicImplant', 'cbIsSpoProsthesis',
			'cbIsSpoPacemakerDef', 'cbIsSpoEarImplant', 'cbIsSpoInsulinPump','cbIsSppPacemakerDef',
			'cbIsSpoForeignBody', 'cbIsSpoAddSurgery', 'cbIsSpoPiercing',
			'cbIsSpoHeartValveRep', 'cbSpoEyeInjureyMetal', 'cbIsSpoDentalObject'];

		for (let key of keys) {
			if (firstSiteProtCOMr[key] && +firstSiteProtCOMr[key] === 2100) {
				return true;
			}
		}

		return false;
	}

	// public initRequestedProcedureFromOrderedProcedureItem(){
	// 	//Remove the exists requestedProcedure items.
	// 	this.requestedProcedure.splice(0,this.requestedProcedure.length);
	//
	// 	if (this.orderedProcedureItem){
	// 		this.orderedProcedureItem.forEach((procedure) => {
	// 			this.addProcedureToRequestedProcedure(procedure.FKLookupRows.rpCodeKey,
	// 				procedure.FKLookupRows.spsCodeKey,  procedure.FKLookupRows.procedureCodeKey);
	// 		});
	// 	}
	// }

	// public addProcedureToRequestedProcedure(rpCode: IRPCodeBaseLookup, spsCode: ISPSCodeBaseLookup, procedureCode: IProcedureCode) {
	// 	let currRequestedProcedure: RequestedProcedure;
	// 	if (this.requestedProcedure) {
	// 		//Check if requestedProcedure array contain the rpCode.
	// 		currRequestedProcedure = this.requestedProcedure.find((requestedProcedure) => {
	// 			return rpCode.rpCodeKey === requestedProcedure.rpCodeKey;
	// 		});
	// 	} else {
	// 		this.requestedProcedure = [];
	// 	}
	//
	// 	if (currRequestedProcedure) {
	// 		//Try to add the procedure to the sps level (if the procedure not exists).
	// 		currRequestedProcedure.AddProcedureToSps(spsCode, procedureCode);
	// 	} else {
	// 		//Add a new requestedProcedure.
	// 		let newRequestedProcedure = new RequestedProcedure();
	// 		let baseRP:IRPCodeBaseLookup =  Object.assign({},rpCode,{rpCodeKey:rpCode.rpCodeKey});
	//
	// 		newRequestedProcedure.SetData(baseRP, spsCode, procedureCode);
	// 		this.requestedProcedure.push(newRequestedProcedure);
	// 	}
	// }

	// public removeProcedureFromRequestedProcedure(rpCode: IRPCode, spsCode: ISPSCode, procedureCode: IProcedureCode){
	// 	if (this.requestedProcedure) {
	// 		let requestedProcedureIndex = this.requestedProcedure.findIndex((requestedProcedure) => {
	// 			return rpCode.RPCodeKey === requestedProcedure.rpCodeKey;
	// 		});
	//
	// 		if (requestedProcedureIndex > -1){
	// 			let currRequestedProcedure = this.requestedProcedure[requestedProcedureIndex];
	// 			currRequestedProcedure.RemoveProcedureFromSps(spsCode, procedureCode);
	//
	// 			//If after the remove the sps array empty then remove the item from the array.
	// 			if (!(currRequestedProcedure.sps && currRequestedProcedure.sps.length)){
	// 				this.requestedProcedure.splice(requestedProcedureIndex, 1);
	// 			}
	// 		}
	// 	}
	// }

	// public addProcedureToOrderedProcedureItem(rpCode: IRPCode, spsCode: ISPSCode, procedureCode: IProcedureCode) {
	// 	if (this.orderedProcedureItem) {
	// 		let procedureIndex = this.getOrderedProcedureIndex(rpCode, spsCode, procedureCode);
	//
	// 		if (procedureIndex === -1){
	// 			this.orderedProcedureItem.push(this.createOrderedProcedureItem(rpCode, spsCode, procedureCode));
	// 		}
	// 	}
	// }
	//
	// public removeProcedureFromOrderedProcedureItem(rpCode: IRPCode, spsCode: ISPSCode, procedureCode: IProcedureCode) {
	// 	if (this.orderedProcedureItem) {
	// 		let procedureIndex = this.getOrderedProcedureIndex(rpCode, spsCode, procedureCode);
	//
	// 		if (procedureIndex > -1) {
	// 			this.orderedProcedureItem.splice(procedureIndex, 1);
	// 		}
	// 	}
	// }
	//
	// public getOrderedProcedureIndex(rpCode: IRPCode, spsCode: ISPSCode, procedureCode: IProcedureCode){
	// 	return this.orderedProcedureItem.findIndex((procedure) => {
	// 		return (procedure.rpCodeKey === rpCode.RPCodeKey && procedure.spsCodeKey === spsCode.SPSCodeKey &&
	// 		((!procedureCode && !procedure.procedureCodeKey) || (procedure.procedureCodeKey === procedureCode.procedureCodeKey)));
	// 	});
	// }
	//
	// public createOrderedProcedureItem(rpCode: IRPCode, spsCode: ISPSCode, procedureCode: IProcedureCode){
	// 	return {
	// 		orderedProcedureKey: -1,
	// 		orderKey: -1,
	// 		lateralityKey: null,
	// 		bodyPartKey: null,
	// 		sequenceId: 0.0,
	// 		studySeriesKey: null,
	// 		rpCodeKey: rpCode.RPCodeKey,
	// 		spsCodeKey: spsCode.SPSCodeKey,
	// 		procedureCodeKey: procedureCode.procedureCodeKey,
	// 		comments: null,
	// 		seriesSequenceId: null,
	// 		displaySortOrder: null,
	// 		duration: spsCode.duration,
	// 		FKLookupRows: {
	// 			rpCodeKey: spsCode,
	// 			spsCodeKey:procedureCode,
	// 			procedureCodeKey: procedureCode,
	// 		}
	// 	};
	// }
}
Order.requestedProcedure_TYPE = RequestedProcedure;
Order.orderedProcedureItem_TYPE = OrderedProcedureItem;
Order.scanDocument_TYPE = ScanDocument;
